import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  ${media.medium`
    margin: 5vw 0 0 0;
    padding: 0 7% 0 14%;
    display: block;
  `}
`;
